<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm10 lg10>
              <div class="x-text-field">
                <label>项目名称</label>
                <div>{{item.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2 lg2>
              <div class="x-text-field">
                <label>审核状态</label>
                <div>{{ item.status ? item.status.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>项目类别</label>
                <div>{{item.type ? item.type.name: ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>委托单位</label>
                <div>{{item.client}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6>
              <div class="x-text-field">
                <label>校内主管部门</label>
                <div>{{item.adminDept? item.adminDept.name : ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm4>
              <div class="x-text-field">
                <label>合同金额</label>
                <div>{{item.contractAmounts | currency}}元</div>
              </div>
            </v-flex>

            <v-flex xs12 sm2 lg2>
              <div class="x-text-field">
                <label>项目性质</label>
                <div>{{propMap[item.property] || item.property}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 lg6>
              <div class="x-text-field">
                <label>负责人</label>
                <div>{{item.leaderName}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>负责人电话</label>
                <div>{{item.leaderPhone}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>负责人邮箱</label>
                <div>{{item.leaderEmail}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 lg6>
              <div class="x-text-field">
                <label>归属部门</label>
                <div>{{ item.department ? item.department.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>开始日期</label>
                <div>{{item.startDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm3 lg3>
              <div class="x-text-field">
                <label>结束日期</label>
                <div>{{item.finishDate}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 lg6>
              <div class="x-text-field">
                <label>学科分类</label>
                <div>{{item.subject ? item.subject.name: ''}}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 lg6>
              <div class="x-text-field">
                <label>研究活动类别</label>
                <div>{{ item.researchType ? item.researchType.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 lg6>
              <div class="x-text-field">
                <label>组织形式</label>
                <div>{{ item.organizeForm }}</div>
              </div>
            </v-flex>

            <v-flex xs12 sm6 lg6>
              <div class="x-text-field">
                <label>合作形式</label>
                <div>{{ item.coopeForm ? item.coopeForm.name : '' }}</div>
              </div>
            </v-flex>

            <!--
            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>
            -->
            <v-flex
              xs12
              v-if="item.attachments && item.attachments.length > 0"
            >
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol>
                <li v-for="a in item.attachments" :key="a.dbid" class="pt-1">
                  <a :href="`/api/proj/attachment/${a.dbid}`" target="_blank">
                    {{a.fileName}}
                    ({{a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/proj/project/appl';

  export default {
    mixins: [mixin.view(baseUri)],
    data: () => ({
      propMap: {
        "zk": "自科",
        "sk": "社科"
      },

      item: {}
    })
  }
</script>
